import React, { useState, useContext } from 'react';
import { AppContext } from 'context/AppContext';

import InfoAboutFullFunctionalityPro from './InfoAboutFullFunctionalityPro';

const UserDetailsSubscription = (props) => {
    let appContext = useContext(AppContext);
    const [isRenewing, setIsRenewing] = useState(false);
    return (
        <>
            <div className="subscription-details-container">
                {appContext.defaults.sub_is_active && !isRenewing ? (
                    <>
                        <div className="header-box">
                            <div className="header">
                                You can renew at any time
                            </div>
                        </div>
                        <div className="price-box">
                            <div className="mark-dolar">$</div>
                            <div className="price">85</div>
                            <div className="per-year">/ year</div>
                        </div>

                        <div className="buttons-box">
                            <div
                                className="btn-renew-now"
                                onClick={() => {
                                    setIsRenewing(true);
                                }}
                            >
                                renew now
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="finalise-purches">
                        <InfoAboutFullFunctionalityPro
                            setIsSubscribe={props.setIsSubscribe}
                            isRenewing={isRenewing}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default UserDetailsSubscription;
